module.exports = __webpack_public_path__ + "static/media/feature-slideg8.389d47fc.jpg";